import { module } from "angular";
import {
    InterpolateFilter,
    UniqueFilter,
    SplitFilter,
    NewLinesFilter,
    JoinFilter,
    PageTitleFilter,
    HighlightTextFilter,
} from "./StringFilters";

module("mmGui")
    .filter("irInterpolate", ["$interpolate", InterpolateFilter])
    .filter("irUnique", UniqueFilter)
    .filter("mmSplit", SplitFilter)
    .filter("mmNewLines", NewLinesFilter)
    .filter("mmJoin", JoinFilter)
    .filter("irPageTitle", PageTitleFilter)
    .filter("irHighlightText", HighlightTextFilter);
